import React, {Component} from "react";
import cookie from "react-cookies";
import {connect} from "react-redux";

import {
    BookOutlined,
    CloseOutlined,
    CloudUploadOutlined,
    DeleteFilled,
    DownloadOutlined,
    ExportOutlined,
    FilterOutlined,
    FolderViewOutlined,
    InfoCircleOutlined,
    RocketFilled,
    SearchOutlined,
    SettingFilled,
    SmallDashOutlined,
    UsergroupAddOutlined
} from '@ant-design/icons';

import {
    Badge,
    Button,
    Col,
    ConfigProvider,
    Divider,
    Input,
    Layout,
    message,
    Modal,
    Pagination,
    Progress,
    Row,
    Select,
    Spin,
    Switch,
    Table,
    Tooltip
} from 'antd';
import {
    deleteSlide,
    setAnalysisFilter,
    slideListUpdateSuccess,
    slideUpdateAlert,
    startDebugUpload,
    startExport,
    startTiling,
    startUpload
} from '../../redux_actions/slides.action'
import {changePage, clearAllFilters, updateTagsAndSearches} from '../../redux_actions/search.action';
import FilterComp from "../dashboard/filter";
import SearchBar from "./searchbar";
import MultipleTagAddition from "../dashboard/multiple.tag.addition";
import {
    antdSpinLoaderIcon,
    ArchiveConstants,
    DeepBioIcon,
    deploymentMode,
    IHCIcon,
    openInNewTabType,
    responsiveLayers,
    slideStatusEnum
} from '../../utils/const'
import {
    customizeRenderEmpty,
    getArchiveComponent,
    getAssignCaseComponent,
    getDbEntryComponent,
    getDeleteComponent,
    getExportComponent,
    getLabelComponent,
    getMorphleIDComponent,
    getPreviewComponent,
    getShareComponent,
    getSlideReadStatusComponent,
    getStarredComponent,
    getTagsComponent,
    getTilingComponent,
    getUnreachableComponent,
    getUploadComponent,
    shortenUnit,
    stitchingPercentComponent
} from "./slidelist_utils";
import CaseSuggestions from "../viewer/viewer.case";
import MultipleCaseSuggestions from "./multiple.case.assign.modal";
import RevokeSlideOwner from "./revoke.slide.owner.access.modal";
import {makeMenuVisible} from "../../redux_actions/context.menu.action";
import copy from 'copy-to-clipboard';
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable'

import {isDeviceIPRemote} from "../../utils/device_utils";
import {startWebsiteTour} from "../../redux_actions/websitetour.action";
import {Redirect} from "react-router-dom";
import querystring from "query-string";

import {
    debounce,
    getPrefixedUrl,
    getPreviewUrl,
    getScanURL,
    getSplitViewerLink,
    isCloud,
    isNull,
    isSuperuser,
    isTrue,
    linkViewer,
    notNull,
    openEndPoint,
    slideStatusCategory,
} from "../../utils/utils";
import {addSlidesToShare} from "../../redux_actions/shareManager.action";
import {get, get_response, post_response} from '../../helper/request'
import {updateTileViewerState} from "../../redux_actions/morpheus.setting.action";
import "../../asset/style/dashboard.css";
import spinLoader from "../common/SpinLoader";
import {aclPermissions, hasPermissions} from "const/ACLPermissions";
import {getCaseNamePlaceholder} from "utils/org_utils";
import SlideReadStatusModal from "../utils/slideReadStatusModal";
import {error_manager} from "../../helper/error_manager";

const {Option} = Select;
const ButtonGroup = Button.Group;

const pageSize = 10;

const headerStyle = {
    textAlign: 'center',
    color: '#fff',
    height: 30,
    paddingInline: 20,
    lineHeight: '30px',
    backgroundColor: '#7dbcea',
    fontSize: '12px'
};

let dataSrc = [];
export class SlideList extends Component {
    constructor(props) {
        super(props);
		this.handleClear = this.handleClear.bind(this);

        this.state = {
            selectedRowKeys: [],
            assignCaseModalVisible: false,
            assignMultipleCaseModalVisible: false,
            changeSlideOwnerModalVisible: false,
            readStatusModalVisible: false,
            selectedSlide: {},
            showTagsSection: false,
            currentHoverRowID: -1,
            currentRowIDForAnalysis: -1,
            analysisFiltersVisible: false, // if true, shows scan analysis filters
            analysisSearchText: '', // to search inside filtered analysis data,
            showAnalysisPanel: false,
            redirect: null,
            devices: [],
            ownersName: [],
            selectedOwner: '',
            loadingSlidesSummary: false,
            modalVisible: false,
            loadingUsers: false,
        }

        this.scanAnalysis = this.props.morpheusSetting.tile_viewer_app_state;
        if (!this.scanAnalysis?.hasOwnProperty("scanAnalysis")) {
            this.scanAnalysis = {
                ...this.scanAnalysis,
                ["scanAnalysis"]: {}
            };
        }
        this.scanAnalysisFilter = this.scanAnalysis["scanAnalysis"];
        this.isMobile = document.documentElement.clientWidth <= responsiveLayers.MOBILE_WIDTH_LEVEL &&
            (document.documentElement.clientWidth < document.documentElement.clientHeight);
        // message.success(`ismobile${this.isMobile}`);
        this.iOS = cookie.loadAll().iOS === "true";
        this.is_superuser = isSuperuser()
        this.is_cloud = isCloud();
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.urlState.searches.length !== this.props.urlState.searches.length ||
            prevProps.urlState.tags.length !== this.props.urlState.tags.length ||
            prevProps.urlState.page !== this.props.urlState.page) {
            this.setState({selectedRowKeys: [], currentRowIDForAnalysis: -1});
        }
    }

	getDevices = () => {
		let url = '/api/get_devices/'
		get(url).then(res => {
            if (notNull(res.data)) {
                this.setState({
                    devices: res.data,
                })
            }
		})
	}

	componentWillMount = () => {
		this.getDevices();
	}

    componentDidMount = () => {
        this.getOwnersName();
        this.debounceFunc = debounce(this.resizeListener, 400)
        window.addEventListener("resize", this.debounceFunc);
    }
    componentWillUnmount = () => {
        window.removeEventListener("resize", this.debounceFunc);
    };
    resizeListener = () => {
        this.forceUpdate();
        this.isMobile = document.documentElement.clientWidth <= responsiveLayers.MOBILE_WIDTH_LEVEL &&
            (document.documentElement.clientWidth < document.documentElement.clientHeight);
    }

    getOwnersName = () => {
        this.setState({loadingUsers: true})
        const url = `/api/user/?only_usernames=true`;
        get_response(url)
            .then(response => {
                if (response.status === 200) {
                    const data = response.data;
                    const usernames = [];
                    data.forEach(userData => {
                        usernames.push(userData.username);
                    })
                    this.setState({ownersName: usernames, loadingUsers: false})
                }
            })
            .catch(() => {
                this.setState({loadingUsers: false})
                message.error("Failed to load users")
            })
    }

    openDownloadModal = () => {
        this.setState({modalVisible: true});
    };

    handleDownloadCancel = () => {
        this.setState({modalVisible: false, loadingSlidesSummary: false, selectedOwner: ""});
    };

    handleUpload = (morphle_id, id, uploadDebug, uploadDebugOnly) => {
        this.props.dispatch(startUpload(morphle_id, id, uploadDebug, uploadDebugOnly));
    }

    handleDebugUpload = (morphle_id, id) => {
        this.props.dispatch(startDebugUpload(morphle_id, id));
    }

    handleDelete = (slide) => {
        this.props.dispatch(deleteSlide(slide, this.props.urlState))
    }

    updateSlideStarring = (selectedSlides, star) => {
        if (selectedSlides.length > 0) {
            let fail_flag = false;
            let url = `/api/update_slide_starring/`;
            let val = {"starSlides": star, "slide_ids": selectedSlides.map(slide => slide.morphle_id)};
            post_response(url, querystring.stringify(val))
                .then(response => {
                    if (response.status === 200 || response.status === 301 || response.status === 302) {
                        selectedSlides.forEach(slide => {
                            slide.starred = star;
                            this.props.dispatch(slideListUpdateSuccess(slide.id, slide));
                        });
                    } else if (response.status === 403 || response.status === 401 || response.status === 400) {
                        fail_flag = true;
                    }
                })
                .catch(err => {
                    fail_flag = true;
                });

            if (fail_flag) {
                message.error('Slide Update Failed', 2.5);
            } else {
                message.success('Slide Update Successful', 2.5);
            }
        }
    }

    starSelectedRows = () => {
        let selected_rows = this.state.selectedRowKeys.map(slideKey => this.props.allSlides[slideKey]);
        this.updateSlideStarring(selected_rows, true)
    }

    uploadSelectedRows = () => {
        this.state.selectedRowKeys.forEach(value => {
            let slide = this.props.allSlides[value];
            this.props.dispatch(startUpload(slide.morphle_id, slide.id, false,
                false));
        });
    }

    tileSelectedRows = () => {
        this.state.selectedRowKeys.forEach(value => {
            this.props.dispatch(startTiling(this.props.allSlides[value].morphle_id, this.props.allSlides[value].id));
        });
    }

    exportSelectedRows = () => {
        this.state.selectedRowKeys.forEach(value => {
            this.props.dispatch(startExport(this.props.allSlides[value].morphle_id, this.props.allSlides[value].name, this.props.allSlides[value].id));
        })
    }


    copySelectedRows = () => {
        let allPaths = "";
        this.state.selectedRowKeys.forEach(value => {
            let scanFolderUrl = this.props.allSlides[value].loc_on_machine + "/scans/" + this.props.allSlides[value].bucket_name + "/" + this.props.allSlides[value].path;
            allPaths += '"' + scanFolderUrl + '",\n';
        });
        copy(allPaths.substring(0, allPaths.length - 2));
        message.info("Path Copied To Clipboard");
    }

    unstarSelectedRows = () => {
        let selected_rows = this.state.selectedRowKeys.forEach(slideKey => this.props.allSlides[slideKey]);
        this.updateSlideStarring(selected_rows, false)
    }

    deleteSelectedRows = () => {
        this.state.selectedRowKeys.forEach(value => {
            if (!this.props.allSlides[value]) return;
            this.handleDelete(this.props.allSlides[value]);
        });
        message.loading("Scheduling slides for Deletion");
        this.setState({selectedRowKeys: []});
    }

    handleStarButton = (slide, input) => {
        this.updateSlideStarring([slide], input)
    };

    handleNameChange = (slide, newName) => {
        let val = {
            morphle_id: slide.morphle_id,
            path: slide.path,
            date: slide.date,
            specimen_type: slide.specimen_type,
            name: newName,
            starred: slide.starred,
            displayOrder: slide.displayOrder
        };
        this.props.dispatch(slideUpdateAlert(slide.id, val));
    };

    handleAssignCase = (slide) => {
        this.setState({
            selectedSlide: slide,
            assignCaseModalVisible: true,
        });
    }

    handleSlideReadStatusModal = (slide) => {
        this.setState({
            selectedSlide: slide,
            readStatusModalVisible: true,
        });
    }

    openMultipleAssignCaseModal = () => {
        this.setState({
            assignMultipleCaseModalVisible: true,
        });
    }

    openChangeOwnerModal = () => {
        this.setState({
            changeSlideOwnerModalVisible: true,
        });
    }

    closeModal = () => {
        this.setState({
            assignCaseModalVisible: false,
        });
    }

    closeMultipleCaseModal = () => {
        this.setState({
            assignMultipleCaseModalVisible: false,
        });
    }

    closeChangeOwnerModal = () => {
        this.setState({
            changeSlideOwnerModalVisible: false,
        });
    }

    handleOwnerChange = (value) => {
        this.setState({selectedOwner: value});
    };

    onDownload = () => {
        this.setState({loadingSlidesSummary: true});
        const doc = new jsPDF();

        const data = [
            ['SL No', 'Label', 'Screenshot', 'Image Size', 'File Name'],
        ];

        get(`/api/create_slides_summary_pdf/?user=${this.state.selectedOwner}`).then(selectedRowKeys => {
            const dataPromises = selectedRowKeys['result'].map((slide, index) => {
                return get(getPrefixedUrl(`meta/size_meta.json`, slide)).then((size) => {
                    let dataDetails = [];
                    let previewPath = slide.preview_image;
                    if (cookie.load('deployment_mode') === deploymentMode.OFFLINE) {
                        previewPath = previewPath.replace("/static/", "");
                        previewPath = getPreviewUrl(previewPath.replace('stitched_small_viewer', 'selection_marked'), slide);
                    }
                    let labelPath = slide.preview_image;
                    if (cookie.load('deployment_mode') === deploymentMode.OFFLINE) {
                        labelPath = labelPath.replace("/static/", "");
                        labelPath = getPreviewUrl(labelPath.replace('stitched_small_viewer', 'barcode_crop'), slide);
                    }
                    dataDetails.push(index + 1);

                    return Promise.all([
                        new Promise((resolve) => {
                            const lImg = new Image();
                            lImg.onload = () => {
                                lImg.width = 50;
                                lImg.height = 50;
                                dataDetails.push(lImg);
                                resolve();
                            };
                            lImg.src = labelPath;
                        }),
                        new Promise((resolve) => {
                            const pImg = new Image();
                            pImg.onload = () => {
                                pImg.width = 50;
                                pImg.height = 50;
                                dataDetails.push(pImg);
                                resolve();
                            };
                            pImg.src = previewPath;
                        }),
                    ]).then(() => {
                        const totalSize = size['total_size_on_hdd'] || size['total_size']
                        dataDetails.push(`${parseFloat((totalSize / 8000000).toFixed(2), 10)} MB`);
                        dataDetails.push(slide['name']);
                        data.push(dataDetails);
                    });
                });
            })
            Promise.allSettled(dataPromises)
                .then(() => {
                    autoTable(doc, {
                        columnStyles: {
                            0: {halign: 'center', valign: 'middle'},
                            3: {valign: 'middle'},
                            4: {valign: 'middle'}
                        },
                        head: [data[0]],
                        bodyStyles: {minCellHeight: 20},
                        body: data.slice(1).sort((a, b) => a[0] - b[0]),
                        didDrawCell: (data) => {
                            if (data.column.index === 1 && data.row.raw[1] !== 'Label') {
                                const img = data.row.raw[data.column.index];
                                doc.addImage(img, 'JPEG', data.cell.x + 2 + 15, data.cell.y + 2, 15, 15, '', 'MEDIUM', -270);
                            }
                            if (data.column.index === 2 && data.row.raw[2] !== 'Screenshot') {
                                const img = data.row.raw[data.column.index];
                                doc.addImage(img, 'JPEG', data.cell.x + 2, data.cell.y + 2, 25, 15);
                            }
                        },
                    });
                    doc.save(`Slides_Summary_${new Date().getTime()}.pdf`);
                    this.setState({loadingSlidesSummary: false, modalVisible: false, selectedOwner: ""});
                })
                .catch((err) => {
                    this.setState({loadingSlidesSummary: false, modalVisible: false, selectedOwner: ""});
                    error_manager("Error generating pdf", err)
                });
        }).catch((err) => {
            this.handleDownloadCancel();
            const msg = err?.response?.data ? err.response.data : "Failed to get download info"
            error_manager(msg, err);
        })
    }

    closeSlideReadStatusModal = () => {
        this.setState({
            readStatusModalVisible: false,
        });
    }

    openDeleteModal = () => {

        var deletedIDs = "";

        this.state.selectedRowKeys.forEach((value, index) => {
            if (!this.props.allSlides[value]) return;
            if (index !== this.state.selectedRowKeys.length - 1) deletedIDs +=
                (this.props.allSlides[value] || {}).name + ", ";
        });

        deletedIDs += this.props.allSlides[this.state.selectedRowKeys[this.state.selectedRowKeys.length - 1]].name;

        const deleteRowsHandle = this.deleteSelectedRows;

        Modal.confirm({
            title: 'Following scans will be deleted. Confirm?',
            icon: <InfoCircleOutlined></InfoCircleOutlined>,
            content: (<Row>{deletedIDs}</Row>),
            onOk() { deleteRowsHandle() },
            onCancel() { }
        });
    }

    openSelectedSlides = (e, selectedSlides) => {
        let selectedSlidesReady = selectedSlides.filter(record => (
            (record.archive_status < ArchiveConstants.STATUS.ARCHIVED ||
            record.archive_status === ArchiveConstants.STATUS.RETRIEVED) &&
            (slideStatusCategory(record.status) === slideStatusEnum.VIEWER_READY)
        ))
        
        let rejectedSlides = selectedSlides
                                .filter(x => !selectedSlidesReady.includes(x))
                                .reduce((msgStr, slide) => `${msgStr}, ${slide.name}`, "");
            
        if(selectedSlidesReady.length === selectedSlides.length) {
            let viewerLink = getSplitViewerLink(selectedSlides);
            openEndPoint(viewerLink, e.ctrlKey, true);
        } else {
            message.error(`Some of the selected slides are still not ready: ${rejectedSlides.substring(2)}`, 2.5);
        }
    }

    getRowActionsIfAtleastOneRowSelected = () => {
        let selectedSlides = [];
        if (this.state.selectedRowKeys.length > 0) {
            for (let i = 0; i < this.state.selectedRowKeys.length; i++) {
                selectedSlides.push(this.props.allSlides[this.state.selectedRowKeys[i]]);
            }
        }
        const belowL5 = document.documentElement.clientWidth <= responsiveLayers.LEVEL_5;

        return this.state.selectedRowKeys.length > 0 ?
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%"}}>
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", maxWidth: belowL5 ? "360px" : "none"}}>
                    <ButtonGroup key={1}>
                        <Button key={6}
                            onClick={() => this.props.dispatch(addSlidesToShare(this.state.selectedRowKeys))}
                            disabled={!hasPermissions([aclPermissions.share_slide])}
                            style={{
                                "color": hasPermissions([aclPermissions.share_slide]) ?
                                    "rgba(0, 0, 0, 0.8)" :
                                    "rgba(0, 0, 0, 0.25)"
                            }}
                        >
                            Share
                            <UsergroupAddOutlined style={{ fontSize: "13px" }} />
                        </Button>
                        {hasPermissions([aclPermissions.split_sync_app]) && <Button key={9} onClick={(e) => this.openSelectedSlides(e, selectedSlides)}>
                            Open {this.state.selectedRowKeys.length > 1 ? "Scans" : "Scan" }
                                <FolderViewOutlined style={{ fontSize: "16px" }} />
                        </Button>}
                        {hasPermissions([aclPermissions.update_slides_in_case]) &&
                            <Button key={5} onClick={this.openMultipleAssignCaseModal}>
                                Add to {getCaseNamePlaceholder()}
                                    <BookOutlined style={{ fontSize: "13px" }} />
                            </Button>}
                        {this.is_superuser &&
                            <Button key={1} onClick={this.tileSelectedRows}>
                                Start Tiling
                            </Button>}
                        {hasPermissions([aclPermissions.export_slide]) &&
                            <Button key={7}
                                onClick={this.exportSelectedRows}
                                style={{
                                    "color": hasPermissions([aclPermissions.export_slide]) ?
                                        "rgba(0, 0, 0, 0.8)" :
                                        "rgba(0, 0, 0, 0.25)"
                                }}
                            >
                                Export
                                <ExportOutlined style={{ fontSize: "13px" }} />
                            </Button>}
                        {!this.is_cloud && hasPermissions([aclPermissions.upload_slide]) &&
                            <Button key={-1}
                                onClick={this.uploadSelectedRows}
                                style={{
                                    "color": hasPermissions([aclPermissions.upload_slide]) ?
                                        "rgba(0, 0, 0, 0.8)" :
                                        "rgba(0, 0, 0, 0.25)"
                                }}
                            >
                                Upload
                                <CloudUploadOutlined style={{ fontSize: "13px" }} />
                            </Button>}
                        <Button key={4}
                            disabled={!hasPermissions([aclPermissions.delete_slide])}
                            onClick={this.openDeleteModal}
                            style={{
                                "color": hasPermissions([aclPermissions.delete_slide]) ?
                                    "rgba(0, 0, 0, 0.8)" :
                                    "rgba(0, 0, 0, 0.25)"
                            }}
                        >
                            Delete
                                <DeleteFilled style={{ fontSize: "13px" }} />
                        </Button>
                        {this.is_superuser && isCloud() && <Button key={6} onClick={this.openChangeOwnerModal}>
                            Remove Owner
                            <SettingFilled style={{ fontSize: "13px" }} />
                        </Button>}
                        {this.is_superuser &&
                            <Button key={8} onClick={this.copySelectedRows}>
                                Copy Path
                            </Button>}
                    </ButtonGroup>
                </div>
                <div className={"row-flex"} style={{minWidth: "240px", justifyContent: "space-between"}}>
                    <div style={{width: belowL5 ? "110px" : "200px", marginRight: "10px"}}>
                        <MultipleTagAddition selectedSlides={selectedSlides} />
                    </div>
                    <div>
                        <Button key={0} className="lighter-danger-button" type="danger" onClick={() => {
                            this.setState({selectedRowKeys: []})
                        }} ghost>
                            Cancel
                        </Button>
                    </div>
                </div>
            </div>
            :
            <div style={{display: 'flex'}}>
                <div style={{flex: 1}}>
                    <Button style={{margin: 2}} onClick={() => {
                        this.setState({
                            selectedRowKeys: Object.keys(this.props.allSlides).filter(key => !this.props.allSlides[key].isDeleted && this.props.allSlides[key].name)
                        })
                    }}>
                        Select All Scans
                    </Button>
                </div>
            </div>;

    }

    getFilters = () => {
        return this.state.selectedRowKeys.length > 0 ? <></> : <FilterComp epxanded={this.ex} devices={this.state.devices} />
    }

    getRowActions = () => {
        return <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
            <div style={{width: "100%"}}>
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", marginTop: "5px"}}>
                    {this.getRowActionsIfAtleastOneRowSelected()}
                </div>
            </div>
            { this.state.selectedRowKeys.length > 0 ? null : this.getFilters()}
        </div>
    }

    getPaginationDiv = () => {
        return <Pagination
            total={this.props.total}
            showTotal={(total, range) =>
                this.isMobile ? `${range[0]}-${range[1]} of ${total}` : `Showing ${range[0]}-${range[1]} out of ${total} total scans`
            }
            current={this.props.urlState.page}
            pageSize={pageSize}
            defaultCurrent={1}
            onChange={this.updatePage}
            size="small"
            className="pagination-mp page-forTour"
        />
    }

    updatePage = (pageNumber) => {
	    this.props.dispatch(changePage(pageNumber, this.props.urlState));
    }

    getTableSource = (allSlides) => {
        let allSlidesList = [];
        Object.keys(allSlides).sort(
            function (a, b) {
                return allSlides[a].displayOrder - allSlides[b].displayOrder;
            }
        ).forEach((key) => {
            let slide = allSlides[key];
            if (!slide.isDeleted && slide.name) {
                allSlidesList.push({
                    id: slide.id,
                    type: openInNewTabType.SLIDE,
                    status: slide.status,
                    morphle_id: slide.morphle_id,
                    only_tiling: slide.only_tiling,
                    specimen_type: slide.specimen_type,
                    viewer_type: slide.viewer_type,
                    slideCard: this.getSlideCard(slide),
                    archive_status: slide.archive_status,
                })
            }
        });

        return allSlidesList;
    }

    getAudienceCard = (slide) => {
        return <div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div>
                    <div>
                        <b>{slide.name}</b>
                    </div>
                </div>
                <div>
                    <div>
                        {getTagsComponent(slide, this.props.dispatch, this.props.urlState, this.isMobile)}
                    </div>
                </div>
                <div>
                    {getPreviewComponent(slide, this.is_cloud, this.isMobile)}
                </div>
            </div>
        </div>
    }

    getGroupActionables = (slide) => {
        const betweenL4AndL5 = document.documentElement.clientWidth > responsiveLayers.LEVEL_5 &&
            document.documentElement.clientWidth <= responsiveLayers.LEVEL_4;
        let marginRight = 8;
        if (betweenL4AndL5) {
            marginRight = 7;
        }
        return <div className={"row-flex"}>
            <div className='star-forTour' style={{marginRight: marginRight}}>
                {getStarredComponent(slide, this.handleStarButton)}
            </div>
            {(slideStatusCategory(slide.status) === slideStatusEnum.VIEWER_READY ? <>
                <div className='share-forTour' style={{marginRight: marginRight}}>
                    {getShareComponent(slide, this.props.dispatch)}
                </div>
                <div className='readStatus-forTour' style={{marginRight: marginRight}}>
                    {getSlideReadStatusComponent(slide, this.handleSlideReadStatusModal)}
                </div>
                <div className='upload-forTour' style={{marginRight: marginRight}}>
                    {getUploadComponent(slide, this.handleUpload, this.handleDebugUpload)}
                </div>
                {this.is_superuser ? <div style={{marginRight: marginRight}}>
                    {getTilingComponent(slide, this.props.dispatch)}
                </div> : null}
                <div className='export-forTour' style={{marginRight: marginRight}}>
                    {getExportComponent(slide, this.props.dispatch)}
                </div>
                {
                    !ArchiveConstants.ACTIVE ? null : <div style={{marginRight: marginRight}}>
                        {getArchiveComponent(slide)}
                    </div>
                }
                <div style={{marginRight: marginRight}}>
                    {getAssignCaseComponent(slide, this.handleAssignCase)}
                </div>
            </> : slideStatusCategory(slide.status) === slideStatusEnum.SCANNING ? <div style={{marginRight: marginRight}}>
                    <div>Scanning</div>
                </div> :
                <div>
                    <div style={{marginLeft: 11, marginRight: marginRight}}>
                        {stitchingPercentComponent(slide)}
                    </div>
                    <div style={{marginRight: marginRight}}>
                        <span style={{fontSize: 10, marginLeft: 11}}>Stitching</span>
                    </div>
                </div>)
            }
        </div>
    }

    getDeepBioProgress = (deepbio_status) =>
        <Tooltip overlayStyle={{ whiteSpace: 'pre-line' }} title={deepbio_status.status}>
            <Progress type="circle" width={25} strokeWidth={10} percent={deepbio_status.progress}
                      strokeColor={deepbio_status.error ? 'red' : deepbio_status.process === 'AI' ?
                          deepbio_status.progress === 100 ? 'green' : 'blue' : 'orange'}
                      format={() => <DeepBioIcon sx={{
                          padding: 0.1, transform: "scale(.6)",
                          filter: "saturate(0%) brightness(60%)"
                      }}/>}/>
        </Tooltip>

    getIHCProgress = (ihc_status) =>
        <Tooltip overlayStyle={{whiteSpace: 'pre-line'}} title={ihc_status.status}>
            <Progress type={"circle"} width={25} strokeWidth={10} percent={ihc_status.progress}
                      strokeColor={ihc_status.error ? 'red' : ihc_status.progress === 100 ? 'green' : 'blue'}
                      format={() => <IHCIcon sx={{
                          padding: 0.1, transform: "scale(.8)",
                          filter: "saturate(0%) brightness(60%)"
                      }}/>}/>
        </Tooltip>

    getSlideProgresses = (slide) => {
        return <>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                {slide.deepbio_status && this.getDeepBioProgress(slide.deepbio_status)}
                {slide.ihc_status && this.getIHCProgress(slide.ihc_status)}
            </div>
        </>
    }

    getSlideInfoCardDetails = (slide) => {
        return <div>
            <div className={'preserve-white-space'}>
                <div>
                    <span style={{ fontWeight: 400 }} className='slide-name-forTour'>{slide.name}</span>
                </div>
                {slide.case_id.length > 0 ?
                    <div style={{ marginTop: 5, fontSize: 12 }}>
                        <span>{"Case Name: " + slide.case_id}</span>
                    </div> : null
                }
            </div>
            <div style={{ marginTop: 10 }}>
                {getTagsComponent(slide, this.props.dispatch, this.props.urlState, this.isMobile)}
            </div>
        </div>
    }

    getActionables = (slide, isBetweenL6AndMobile) => {
        return <div className={"row-flex"} style={{marginTop: "10px", marginBottom: "10px", marginLeft: isBetweenL6AndMobile ? "10px":0}}>
                <div style={{marginRight: "10px"}}>
                    {getDbEntryComponent(slide)}
                </div>
                <div style={{marginRight: "10px"}}>
                    {getMorphleIDComponent(slide)}
                </div>
                {hasPermissions([aclPermissions.delete_slide]) ?
                    <div style={{marginRight: "10px"}}>
                        {getDeleteComponent(slide, this.handleDelete)}
                    </div> :
                    null
                }
        </div>
    }

    getDateTimeInfo = (dateTime, annoCount) => {
        dateTime = dateTime.replace("Z", "")
        dateTime = dateTime.substring(0, dateTime.length-6)
        const date_time = new Date(dateTime);
        return <>
            <span>
                    {date_time.toLocaleString('en-us', {day: 'numeric', month: 'short', year: 'numeric'})}
            </span>
            <span>
                    {date_time.toLocaleString('en-US', {hour: 'numeric', minute: 'numeric', hour12: true})}
            </span>
            {this.is_superuser ? <Tooltip title={`${annoCount} Annotations`}>{annoCount}</Tooltip> : null }
        </>
    }

    getSlideScanningDetails = (slide) => {
        return <>
            <div>{slide.specimen_type === "AUTO" || slide.specimen_type === "HNE_TISSUE" ? "HNE" : slide.specimen_type}</div>
            <div>{slide.scan_speed}</div>
            <div>{slide.scan_time}</div>
            {hasPermissions([aclPermissions.devices_menu]) && !this.state.showAnalysisPanel
            && document.documentElement.clientWidth > responsiveLayers.LEVEL_2 ?
                slide.device_name : null
            }
        </>
    }

    getSlideScanAreaAndTime = (slide) => {
        if (isNull(slide)) return
        return <div style={{marginRight: "15px", width: "80px"}}>
            {!this.state.showAnalysisPanel ? <div>{slide.rescan_time}</div> : null}
            <div>{slide.scan_area ? slide.scan_area : slide.area_of_box_scanned.toFixed(2)} mm2</div>
        </div>
    }

    getSlideInfo = (slide) => {
        const aboveL3 = document.documentElement.clientWidth > responsiveLayers.LEVEL_3;
        const aboveL4 = document.documentElement.clientWidth > responsiveLayers.LEVEL_4;
        const aboveL5 = document.documentElement.clientWidth > responsiveLayers.LEVEL_5;

        return (
            <div style={{
                marginTop: "auto",
                display: "flex",
                flexDirection: "row",
                justifyContent: aboveL5 ? "flex-start" : "flex-end"
            }}>
                {aboveL3 ? (
                    <>
                        <div className={"column-flex"} style={{alignItems: "flex-start", marginRight: 15}}>
                            {this.getDateTimeInfo(slide.date_time, slide.annotation_count)}
                        </div>
                        {hasPermissions([aclPermissions.view_slide_details]) && !this.state.showAnalysisPanel ?
                            <div style={{marginRight: 15, marginLeft: this.is_superuser ? 10 : 40, width: '100px'}}>
                                <div>{slide.owner_name}</div>
                            </div> : null
                        }
                        {hasPermissions([aclPermissions.view_slide_details]) ?
                            <div style={{marginRight: 15, width: "61px"}}>
                                {/*// TODO: don't show if AUTO*/}
                                {this.getSlideScanningDetails(slide)}
                            </div> : null
                        }
                        {this.is_superuser ? this.getSlideScanAreaAndTime() : null}
                    </>
                ) : aboveL4 ? (
                    <div style={{marginTop: "auto", display: "flex", flexDirection: "row"}}>
                        <div className={"column-flex"}
                             style={{alignItems: "flex-start", marginRight: 15, minWidth: 80}}>
                            {this.getDateTimeInfo(slide.date_time, slide.annotation_count)}
                        </div>
                        {this.is_superuser ? this.getSlideScanAreaAndTime() : <>
                            {hasPermissions([aclPermissions.view_slide_details]) && !this.state.showAnalysisPanel ?
                                <div style={{marginRight: 15, width: "60px"}}>
                                    <div>{slide.owner_name}</div>
                                </div> : null
                            }
                            {hasPermissions([aclPermissions.view_slide_details]) ?
                                <div style={{width: "61px"}}>
                                    {this.getSlideScanningDetails(slide)}
                                </div> : null
                            }
                        </>}
                    </div>
                ) : (
                    <div style={{marginTop: "auto", display: "flex", flexDirection: "row", justifyContent: "flex-end"}}>
                        <div className={"column-flex"}
                             style={{alignItems: aboveL5 ? "flex-start" : "flex-end", marginRight: 10, marginLeft: 10}}>
                            {this.getDateTimeInfo(slide.date_time, slide.annotation_count)}
                        </div>
                        {this.is_superuser && aboveL5 ?
                            <div style={{width: "61px"}}>
                                {this.getSlideScanningDetails(slide)}
                            </div> : null}
                    </div>
                )}
            </div>
        );
    };

    getSlideCard = (slide) => {
        const betweenL4AndL5 = document.documentElement.clientWidth > responsiveLayers.LEVEL_5 &&
            document.documentElement.clientWidth <= responsiveLayers.LEVEL_4;
        const belowL2 = document.documentElement.clientWidth <= responsiveLayers.LEVEL_2;
        const belowL3 = document.documentElement.clientWidth <= responsiveLayers.LEVEL_3;
        const aboveL5= document.documentElement.clientWidth > responsiveLayers.LEVEL_5;
        const aboveL0= document.documentElement.clientWidth > responsiveLayers.LEVEL_0;
        const betweenL6AndMobile = document.documentElement.clientWidth <= responsiveLayers.LEVEL_6 &&
            document.documentElement.clientWidth > responsiveLayers.MOBILE_WIDTH_LEVEL;

        if ((JSON.parse(localStorage.getItem('morpheus_setting')) || {}).is_audience) {
            this.getAudienceCard(slide);
        } else {
            return (this.isMobile ?
                    <Row style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        <Col span={10}>
                            {this.getSlideInfoCardDetails(slide)}
                        </Col>
                        {isDeviceIPRemote(slide.device_ip) && slide.ping === false ? // slide.ping undefined to be treated as else
                            <Col span={6}>
                                {getUnreachableComponent(slide)}
                            </Col> :
                            <Col span={12} style={{paddingTop: 1, paddingBottom: 1}}>
                                <Row>
                                    <Col span={17}>
                                        {getPreviewComponent(slide, this.is_cloud, this.isMobile)}
                                    </Col>
                                    <Col span={5} offset={2}>
                                        {getLabelComponent(slide, this.is_cloud, this.isMobile, true)}
                                    </Col>
                                </Row>
                                <Row style={{paddingTop: 2}}>
                                    <Col span={24} className={"flex-start"}>
                                        {this.getDateTimeInfo(slide.date_time)}
                                    </Col>
                                </Row>

                            </Col>
                        }
                    </Row> :
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}
                         className="slide-entry-forTour">
                        {aboveL5 ? <div className={"row-flex"} style={{
                            width: betweenL4AndL5 ? "25%" : belowL3 ? "20%" : "17%",
                            flexShrink: 0
                        }}>
                            <div className={"group-actionable-container"} style={{width: "100%"}}>
                                {this.getGroupActionables(slide)}
                            </div>
                            {!isCloud() && !this.state.showAnalysisPanel && aboveL0 ?
                                this.getSlideProgresses(slide) : null}
                        </div> : null}
                        <div style={{width: betweenL6AndMobile ? "32%" : betweenL4AndL5 ? "22%" : "20%"}}>
                            {this.getSlideInfoCardDetails(slide)}
                        </div>
                        {isDeviceIPRemote(slide.device_ip) && slide.ping === false ? // slide.ping undefined to be treated as else
                            <div>
                                {getUnreachableComponent(slide)}
                            </div> :
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "auto",
                                    gap: betweenL4AndL5 ? 0 : "10px"
                                }}>
                                <div>
                                    {getPreviewComponent(slide, this.is_cloud, this.isMobile)}
                                </div>
                                <div className="rotate270">
                                    {getLabelComponent(slide, this.is_cloud, this.isMobile, false)}
                                </div>
                            </div>
                        }
                        <div>
                            {this.getActionables(slide, betweenL6AndMobile)}
                            {this.getSlideInfo(slide)}
                        </div>
                    </div>
            )
        }
    }

    searchTag = (tag) => {
        let currentTags = this.props.urlState.tags;
        if (currentTags.includes(tag)) {
            const index = currentTags.indexOf(tag);
            if (index > -1) {
                currentTags.splice(index, 1);
            }
        } else {
            currentTags.push(tag);
        }
        this.props.dispatch(updateTagsAndSearches(currentTags, [], [], this.props.urlState));
    }

    showAnalysisFilters = () => {
        this.setState({
            analysisFiltersVisible: true,
        });
    }

    hideAnalysisFilters = () => {
        this.setState({
            analysisFiltersVisible: false,
        });
    }

    copyCSV = () => {
        let csvData = "";
        Object.keys(dataSrc).forEach((test) => {csvData += dataSrc[test].key+","+dataSrc[test].value+"\n"})
        copy(csvData);
        message.info("Path Copied To Clipboard");
    }

    toggleAnalysisFilter = (key) => {
        this.scanAnalysisFilter[key] = !this.scanAnalysisFilter[key];
        this.props.dispatch(updateTileViewerState(this.scanAnalysis));
        this.props.dispatch(setAnalysisFilter(key, this.scanAnalysisFilter[key]))
    }

    getAnalysisFilterSelector = () => {
        return <div>
            <Row>
            {Object.keys(this.props.analysis_key_prefixes).map(key => {
                return <Col>
                    <Button size={"small"} type={this.scanAnalysisFilter[key] ? "primary" : "default"}
                            onClick={() => this.toggleAnalysisFilter(key)}>{key}</Button>
                    </Col>;
            })}
            </Row>
        </div>;
    }

    getFilteredAnalysisData = () => {
        let filteredData = {};
        if (this.state.currentRowIDForAnalysis === -1 || this.props.allSlides[this.state.currentRowIDForAnalysis] === undefined) {
            return null;
        } else {
            let data = this.props.allSlides[this.state.currentRowIDForAnalysis]['scan_analysis'];
            if (notNull(data)) {
                if (Object.keys(this.props.analysis_key_prefixes).every(key => isNull(this.scanAnalysisFilter[key]) || this.scanAnalysisFilter[key] === false)) {
                    filteredData = Object.assign({}, data);
                } else {
                    Object.keys(data).forEach(key => {
                        Object.keys(this.props.analysis_key_prefixes).forEach(prefix => {
                            if (!(key in filteredData) && this.scanAnalysisFilter[prefix] && key.startsWith(prefix)) {
                                filteredData[key] = data[key];
                            }
                        });
                    });
                }
            }
            // search inside filtered_data
            let matchingData = {};
            if (this.state.analysisSearchText.length === 0) {
                matchingData = filteredData;
            } else {
                Object.keys(filteredData).forEach(key => {
                    if (key.includes(this.state.analysisSearchText)) {
                        matchingData[key] = filteredData[key];
                    }
                });
            }

            let sortable = [];
            for (var key in matchingData) {
                sortable.push([key, matchingData[key]]);
            }

            dataSrc = [];
            for (var entry of sortable) {
                dataSrc.push({key: entry[0], ...entry[1], valuecustom: `${entry[1].value} ${shortenUnit(entry[1].unit)};${entry[1].type}`});
            }

            const columns = [
                {
                    title: 'Key',
                    dataIndex: 'key',
                    key: 'key',
                    sorter: (a, b) => {
                        return a.key.localeCompare(b.key);
                    }
                },
                {
                    title: 'Value',
                    dataIndex: 'valuecustom',
                    key: 'valuecustom',
                    defaultSortOrder: 'descend',
                    sorter: (a, b) => {
                        let val_a = parseFloat(a.value);
                        let val_b = parseFloat(b.value);
                        return val_a -  val_b;
                    },
                    render: (text) => <Tooltip title={`type: ${text.split(";")[1]}`}>{text.split(";")[0]}</Tooltip>,
                },
                {
                    title: 'Meta',
                    dataIndex: 'meta',
                    key: 'meta',
                    render: (text) => <Tooltip title={JSON.stringify(text)}><SmallDashOutlined /></Tooltip>,
                },
              ];
            
            return <Row>
                    <Row justify="space-around" align="middle">
                        <Col span={24}>
                            <Input placeholder="search keys eg: scan" prefix={<SearchOutlined />} 
                            value={this.state.analysisSearchText} allowClear onChange={this.onFilterSearchChange} />
                        </Col>
                    </Row>
                    <Divider></Divider>
                    <Row>
                        <Col>
                            <Table
                                className="analysis-data-table"
                                columns={columns}
                                pagination={{hideOnSinglePage: true, pageSize: 20}}
                                dataSource={dataSrc}
                            />
                        </Col>
                    </Row>
                </Row>;
        }
    }

    onFilterSearchChange = (e) => {
        // e.target.value
        this.setState({
            analysisSearchText: e.target.value
        });
    }

	handleClear() {
		this.props.dispatch(clearAllFilters());
	}

    toggleAnalysisPanel = (switchValue) => {
        this.setState({
            showAnalysisPanel: switchValue
        });
    }

    render() {

        let redirectURL = null;

        if(isTrue(this.props.tourStatus?.tourActiveForScan)){
            Object.keys(this.props.allSlides).some((key) => {
                if(slideStatusCategory(this.props.allSlide[key].status) === slideStatusEnum.VIEWER_READY) {
                    redirectURL = this.props.allSlides[key].id
                    return true;
                }
                return false;
            });
        }

        if (notNull(redirectURL)) {
            window.history.pushState('', 'dashboard_url', window.location.href)
            return <Redirect to={"/gamma/"+ redirectURL} />;
        }


        // Redirecting here since we need to pass redux data into scan (Redirecting resets redux state)
        if (notNull(this.state.redirect)) {
            // Back button should go to dashboard
            window.history.pushState('', 'dashboard_url', window.location.href)
            return <Redirect to={this.state.redirect} />;
        }

        let tableSource = this.getTableSource(this.props.allSlides);

        let finalColumns = [{
            dataIndex: 'slideCard',
            key: 'slideCard',
        }];
        finalColumns = finalColumns.map(col => {
            if (col.dataIndex === 'tagsComponent') {
                return col;
            } else {
                return {
                    ...col,
                    onCell: record => ({
                        onClick: (event) => {
                            if (record.archive_status < ArchiveConstants.STATUS.ARCHIVED ||
                                record.archive_status >= ArchiveConstants.STATUS.RETRIEVED)
                                if (event.ctrlKey)
                                    if (slideStatusCategory(record.status) === slideStatusEnum.VIEWER_READY)
                                        linkViewer(record, '', true);
                                    else
                                        message.error("Scanning going on!!", 2.5);
                                else if (slideStatusCategory(record.status) === slideStatusEnum.VIEWER_READY) {
                                    this.setState({redirect: getScanURL(record)})
                                }
                                else
                                    message.error("Scanning going on!!", 2.5);
                        },
                    }),
                };
            }
        });

        const rowSelection = {
            onChange: (selectedRowKeys) => {
                this.setState({
                    selectedRowKeys: selectedRowKeys
                })
            },
            selectedRowKeys: this.state.selectedRowKeys
        };

        const onRow = (record) => {
            return {
                onContextMenu: (event) => {
                    event.preventDefault();
                    this.props.dispatch(makeMenuVisible({ visible: true, x: event.clientX, y: event.clientY,
                        record: record, height: this.props.height }));
                },
                onMouseEnter: (event) => {
                    event.preventDefault();
                    this.setState({
                        currentHoverRowID: record.id,
                        currentRowIDForAnalysis: record.id,
                    });
                },
                onMouseLeave: (event) => {
                    event.preventDefault();
                    this.setState({
                        currentHoverRowID: -1,
                    });
                }
            };
        }

        let rowActions = this.isMobile ? undefined :
            [
                <Divider key={3} />,
                <Row key={0} className="row-actions">
                    {this.getRowActions()}
                </Row>
            ];

        const showAnalysisPanelFlexStyle = {display: "flex", flexDirection: "column", alignItems: "center"};
        let offsetForAnalysisPanel = 1;

        return (
            <React.Fragment><Row key={0} className="fixed-controls-dashboard" id="fixed-controls-dashboard">
                <Col span={24}>
                    <Row key={-2} style={{ marginTop: 30 , display: "flex"}}>
                        <Col span={this.isMobile ? 6:11} offset={this.isMobile ? 7:6}>
                            <SearchBar devices={this.state.devices}/>
                        </Col>
						<Col offset={this.isMobile ? 3:1} span={this.isMobile ? 4:2}>
							<Button type={this.state.showTagsSection ? "primary" : ""} onClick={() => {
								this.setState({ showTagsSection: !this.state.showTagsSection }) }}>
								{this.state.showTagsSection ? "Hide All Tags" : "Show All Tags"}
							</Button>
						</Col>
                        {!this.isMobile && this.is_superuser && document.documentElement.clientWidth > responsiveLayers.LEVEL_0  ?
                            <Col span={3} offset={offsetForAnalysisPanel}>
                                <Switch style={document.documentElement.clientWidth > responsiveLayers.LEVEL_0 ? {}:showAnalysisPanelFlexStyle} checked={this.state.showAnalysisPanel}
                                        onChange={this.toggleAnalysisPanel}/> <span
                                style={{fontSize: '14px', fontWeight: 100, letterSpacing: 'normal'}}
                            >Show Analysis Panel</span>
                            </Col>
                            : null
                        }
                    </Row>
                    {this.state.showTagsSection ?
                        <Row style={{marginBottom: 5}}>
                            <div className="tags-section">
                                {this.props.allTags.map(tag => {
                                    let tagElem;
                                    tagElem = (
                                        <Button
                                            size="small"
                                            onClick={() => this.searchTag(tag)}
                                            className={this.props.urlState.tags.includes(tag) ?
                                                "tags-button lighter-danger-button" :
                                                "tags-button"}
                                            type={this.props.urlState.tags.includes(tag) ? "danger" : "primary"}
                                            ghost
                                        >
                                            {tag}
                                        </Button>
                                    );
                                    return tagElem;
                                })}
                            </div>
                        </Row>
                        : null
                    }
                    <Row key={-1}>
                        <div style={this.isMobile ? {
                            display: "flex",
                            justifyContent: "space-between",
                            flexDirection: "column"
                        } : {}}>
                            <div style={{display: "flex", alignItems: "center"}}>
                                <Button onClick={() => {
                                    this.props.dispatch(startWebsiteTour())
                                }} size={"default"} shape={"round"}>
                                    <RocketFilled/>
                                    VISUAL TOUR
                                </Button>
                                {hasPermissions([aclPermissions.download_scans_list]) &&
                                    cookie.load('deployment_mode') === deploymentMode.OFFLINE && (
                                        <div>
                                            <Button key={10} onClick={this.openDownloadModal} style={{margin: 2}}
                                                    shape={"round"}>
                                                <DownloadOutlined style={{fontSize: "13px"}}/>DOWNLOAD
                                            </Button>
                                            <Modal
                                                title="Download Slides Summary"
                                                visible={this.state.modalVisible}
                                                onOk={this.onDownload}
                                                onCancel={this.handleDownloadCancel}
                                                okText={this.state.loadingSlidesSummary ? 'Loading...' : 'Download'}
                                                okButtonProps={{disabled: !this.state.selectedOwner}}
                                            >
                                                <Spin spinning={this.state.loadingUsers} indicator={antdSpinLoaderIcon}>
                                                    Select User:
                                                    <Select
                                                        value={this.state.selectedOwner}
                                                        style={{width: 200, marginLeft: 10}}
                                                        placeholder="Select user"
                                                        onChange={this.handleOwnerChange}
                                                    >
                                                        {this.state.ownersName.map((option) => (
                                                            <Option key={option} value={option}>
                                                                {option}
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </Spin>
                                            </Modal>
                                        </div>
                                )}
                                <div style={{marginLeft: "auto"}}>{this.getPaginationDiv()}</div>
                            </div>
                        </div>

                    </Row>
                    <Row key={0}>

                    </Row>
                    {rowActions}
                    <Divider />
                </Col>
            </Row>
            <Row key={1} className="scrollable-dashboard">
                <Row>
                    <Col span={this.state.showAnalysisPanel ? 18 : 24}>
                        <ConfigProvider renderEmpty={customizeRenderEmpty}>
                            <Table
                                key={1}
                                loading={this.props.isFetching}
                                dataSource={tableSource}
                                columns={finalColumns}
                                rowKey="id"
                                pagination={false}
                                showHeader={false}
                                rowSelection={this.isMobile ? undefined : rowSelection}
                                onRow={onRow}
                                className={"table-dashboard"}
                                rowClassName="slide-table-rows custom-table-padding"
                                indicator={spinLoader}
                            />
                        </ConfigProvider>
                    </Col>
                    {this.state.showAnalysisPanel ? 
                    <Col span={6} style={{height: "90vh", position: "sticky", top: "10px"}}>
                        <Layout>
                            <Layout.Header style={headerStyle}>
                                <div style={{display: "inline-flex", gap: "16px", alignItems: "center"}}>
                                    {this.state.analysisFiltersVisible ?
                                    "Filters" :
                                    (this.state.currentRowIDForAnalysis === -1 || this.props.allSlides[this.state.currentRowIDForAnalysis] === undefined) ? "Hover over scan" : "Scan " + this.props.allSlides[this.state.currentRowIDForAnalysis].name}
                                    {this.state.analysisFiltersVisible ?
                                    <CloseOutlined title={"Close filters"} size="large" onClick={() => this.hideAnalysisFilters()}></CloseOutlined> :
                                    <>
                                    <Badge dot count={Object.values(this.props.analysis_key_prefixes).filter(Boolean).length}>
                                        <FilterOutlined title={"Select keys to filter data"} style={{fontSize: "18px"}} onClick={() => this.showAnalysisFilters()} />
                                    </Badge>
                                    <Button
                                        onClick={ () => {
                                            this.copyCSV()
                                        }}
                                        style={headerStyle}
                                        type="primary"
                                        >
                                            Copy as CSV
                                    </Button>
                                    </>
                                    }
                                </div>
                            </Layout.Header>
                            <Layout.Content style={{backgroundColor: "#ffffff"}}>
                                {this.state.analysisFiltersVisible ? 
                                <Row>
                                    {this.getAnalysisFilterSelector()}
                                </Row>:
                                <Row>
                                    {this.state.currentRowIDForAnalysis === -1 ? "Hover over a scan to see data": null}<br/>
                                    {this.getFilteredAnalysisData()}
                                </Row>
                                }
                            </Layout.Content>
                        </Layout>
                    </Col>
                    : null}
                    
                </Row>
                <Row key={2}>
                    {this.getPaginationDiv()}
                </Row>
            </Row>
            {this.state.assignCaseModalVisible ? <CaseSuggestions modalVisible={this.state.assignCaseModalVisible} selectedSlide={this.state.selectedSlide}
                             closeModal={this.closeModal} />:null}
            <MultipleCaseSuggestions modalVisible={this.state.assignMultipleCaseModalVisible}
                                     selectedRowKeys={this.state.selectedRowKeys}
                                     closeModal={this.closeMultipleCaseModal} />
            <RevokeSlideOwner modalVisible={this.state.changeSlideOwnerModalVisible}
                              selectedRowKeys={this.state.selectedRowKeys} closeModal={this.closeChangeOwnerModal}
                              totalSlides={this.props.total} />
            <SlideReadStatusModal modalVisible={this.state.readStatusModalVisible}
                                  slideId={this.state.selectedSlide?.id} slideName={this.state.selectedSlide?.name} closeModal={this.closeSlideReadStatusModal} />
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {

    return {
        allSlides: state.slidesReducer,
        isFetching: state.searchReducer.isFetching,
        analysis_key_prefixes: state.dashboardReducer.analysis_key_prefixes,
        numPages: state.dashboardReducer.numPages,
        total: state.dashboardReducer.total,
        urlState: state.searchReducer,
        allTags: state.dashboardReducer.allTags,
		tourStatus: state.websiteTourReducer,
        morpheusSetting: state.morpheusSettingReducer,
        allGroups: state.searchUserReducer.groups
    }
}

export default connect(mapStateToProps)(SlideList);
